/* global instantsearch algoliasearch */
import algoliasearch from 'algoliasearch/lite';
import instantsearch from 'instantsearch.js';

import { toggleRefinement, refinementList, hierarchicalMenu, hits, pagination, clearRefinements } from 'instantsearch.js/es/widgets';


import './algolia-min.css'
import './index.css'
import './app.css'

(function() {
  document.getElementById("toggle-filter-button").addEventListener("click", function(){ 
    var x = document.getElementById("left-panel-filter");
  var x = document.getElementById("leftPanel");
          if (x.style.display === "none" || x.style.display === "") {
            x.style.display = "block";
          } else {
            x.style.display = "none";
          }
}); 

const search = instantsearch({
  indexName: 'covid-agencies',
  searchClient: algoliasearch('UCYA0W34YI', '11ed1e3d7bf9bbe17720e1e8bb26060c'),
});

search.addWidgets([
  // instantsearch.widgets.searchBox({
  //   container: '#searchbox',
  // }),
  clearRefinements({
    container: '#clear-refinements',
    templates: {
      resetLabel: 'Supprimer les filtres',
    }
  }),

  refinementList({
    container: '#brand-list',
    attribute: 'department',
    searchable: true,
    limit: 100,
    searchablePlaceholder: 'Rechercher un N° ou nom',
  }),

  hierarchicalMenu({
    container: '#shipment-list',
    attributes: ['shipment'],
  }),

  hits({
    container: '#hits',
    templates: {
      item: `
        <div>
          <div class="hit-name">
            {{#helpers.highlight}}{ "attribute": "agency" }{{/helpers.highlight}}
          </div>
          <div class="hit-description">
            {{address}}<br/>
            {{zipcode}} {{city}}<br />
            {{phone}}<br />
            <span class="hit-shipment">{{shipment}}</span>
          </div>
        </div>
      `,
    },
  }),

  pagination({
    container: '#pagination',
    totalPages: 5
  }),
]);

search.start();


})();

